import { render, staticRenderFns } from "./ZDCoaNote.vue?vue&type=template&id=dbf8b12a&"
import script from "./ZDCoaNote.vue?vue&type=script&lang=js&"
export * from "./ZDCoaNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports